export default {
  message: {
    "strid1": "Halaman Utama",
    "strid2": "Tutorial",
    "strid3": "Acara",
    "strid4": "Sertai Kami",
    "strid5": "Discord",
    "strid6": "Akademi Pencipta",
    "strid7": "Pilihan Kerja",
    "strid8": "Kembali",
    "strid9": "Sertai Sekarang",
    "strid10": "Lebih Banyak Acara",
    "strid11": "Maklumat Peribadi",
    "strid12": "Server Permainan",
    "strid13": "Sila masukkan Server anda",
    "strid14": "ID Permainan",
    "strid15": "Sila masukkan ID permainan anda",
    "strid16": "Maklumat untuk Dihubungi",
    "strid17": "Pilih Platform",
    "strid18": "Sila masukkan maklumat anda untuk dihubungi",
    "strid19": "Perincian Kerja",
    "strid20": "Platform Penerbitan",
    "strid21": "Sila masukkan pautan yang betul",
    "strid22": "Tekan untuk tambah pautan baharu",
    "strid23": "Bahasa Digunakan",
    "strid24": "Pilih bahasa digunakan",
    "strid25": "Inggeris",
    "strid26": "Arab",
    "strid27": "Sepanyol",
    "strid28": "Portugis",
    "strid29": "Khmer",
    "strid30": "Burma",
    "strid31": "Malaysia",
    "strid32": "Lain-Lain",
    "strid33": "Saya mengesahkan pemilikan kerja ini dan memahami perjanjian ini",
    "strid34": "Hantar",
    "strid35": "Telah Dihantar!",
    "strid36": "Kelebihan",
    "strid37": "Sertai kami sekarang demi mendapatkan",
    "strid38": "Sokongan daripada media sosial rasmi MLBB",
    "strid39": "Komuniti interaktif pencipta",
    "strid40": "Ganjaran Berlian Mingguan",
    "strid41": "Lebih banyak kelebihan untuk dibuka",
    "strid42": "Produk Permainan",
    "strid43": "Acara Luar Talian",
    "strid44": "Skin yang banyak",
    "strid45": "Kerjasama jenama",
    "strid46": "Promosi iklan",
    "strid47": "SERTAI KAMI",
    "strid48": "Syarat-syarat",
    "strid49": "IKUTI KAMI",
    "strid50": "Klik untuk melihat akaun rasmi MLBB",
    "strid51": "Kandungan Perjanjian",
    "strid52": "Tolong sempurnakan maklumat",
    "strid53": "Penghantaran Gagal",
    "strid54": "Sila isikan pautan yang betul untuk saluran anda",  // 请输入正确的频道链接
    "strid55": "Pilih rantau anda",
    "strid56": "Rantau Anda",



  }
}
